import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/domain/item-page-data'

export const getItemPageBuyerProtectionInfoPluginModel = (itemDto: ItemDetailsDto) => ({
  itemId: itemDto.id,
  isSellerBusiness: itemDto.user.business,
  itemUserId: itemDto.user.id,
})

export const getServerItemPageBuyerProtectionInfoPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
) => ({
  itemId: sidebarDto.id,
  isSellerBusiness: sidebarDto.business,
  itemUserId: sidebarDto.seller_id,
})
